import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BodyCopy } from "../../components/BodyCopy";
import {
  Button,
  Layout,
  PageTitle,
  AuraLayout,
} from "lola-framework-ui-test";
import { ErrorAlertIcon as ErrorIcon } from "../../assets/icons";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { PAYOUT_CLAIM_ROUTES } from "../../constants";
import { useStore } from "../../store/globalState";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";

export const ClaimBlockedPage = memo(() => {
  const { t } = useTranslation("payout-claim");
  const { theme } = useStore();
  const navigate = useNavigate();
  const colorConfig = theme.errorView;
  const { backgroundBtn, textColorBtn, title, bodyCopy, iconColors, backgroundIcon } =
    colorConfig;

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />

        <section className="flow-hero">

          <FlowHeroMark backgroundIcon={backgroundIcon}>

            <ErrorIcon size={60} colors={iconColors} />

          </FlowHeroMark>
        <section className="landing-container">
          <PageTitle
            highlight={t("error.claimUnavailableTitle")}
            highlightColor={title}
            secudnary=""
            secudnaryColor={title}
          />
          <BodyCopy textColor={bodyCopy}>
            {t("error.claimUnavailableMessage")}
          </BodyCopy>
        </section>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          <Button
            size="large"
            background={backgroundBtn}
            color={textColorBtn}
            onClick={() => navigate(PAYOUT_CLAIM_ROUTES.TRANSACTIONS)}
          >
            {t("error.goToApp")}
          </Button>
        </section>
      </Layout.Footer>
    </AuraLayout>
  );
});
